import workspace from "../components/canvas/core/workspace";
//import {updateCurrentQuote} from "../../../../../misc/quotesFunctions";
import {
  getCurrentQuoteRoomCartItem,
  getRoomCartItemForCategoryName
} from "../../../misc/categorySwitchingFunctions";
import store from "../../../store";
import {setActiveQuoteIndex, setQuotes} from "../../../actions/roomsFunctions";
import {addToCart, changeCartFeature, removeFromCart} from "../../../actions/actionFunctions";
import {prepareSQFTData} from "../components/canvas/core/workspace/workspaceDataMapper";
import {getFeatureGroup, getNavItems, onSQFTLoadImport, onSQFTLoadPrepareData} from "./sqftHelperUi";
import {ACTIVE_ROOM_TYPE} from "../../../reducers/sqftMenuReducer";
import {
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType
} from "../../../actions/sqftMenuFunctions";
import {getRoomNameInQuote} from "../../popups/sqftFeaturesPopup/parseSqftData";
import {getQtCategoryName} from "../../visComponents/qtCategoryName";
import {getStringFeatureName} from "../../../misc/helpers";
import {MEASURE_UNITS} from "../constants";

/**
 *
 */
export const getQtCatName = () => {
  const reduxState = store.getState();
  const {activeRoomType} = reduxState.sqftMenuState;
  const {qtActiveCategory} = reduxState.qtState;
  const {activeRoomId} = reduxState.sqftMenuState;
  const {activeQuoteIndex} = reduxState.quotesState;
  const fabricatorData = reduxState.fabricatorState;
  const intl = workspace.intl;

  let switcherTitle;
  let roomNavItem;

  switch (activeRoomType) {
    case ACTIVE_ROOM_TYPE.quote:
      switcherTitle = getRoomNameInQuote(activeQuoteIndex);
      break;
    case ACTIVE_ROOM_TYPE.category:
      switcherTitle = getQtCategoryName(qtActiveCategory, intl, fabricatorData)
      break;
    case ACTIVE_ROOM_TYPE.roomGroup:
      roomNavItem = getRoomGroupById(activeRoomId);
      if (!roomNavItem) {
        switcherTitle = ""
      } else {
        switcherTitle = getStringFeatureName(roomNavItem.part, intl.messages, intl.locale, fabricatorData);
      }
      break;
  }

  return switcherTitle;
}
/**
 * @param qtCatName string
 */
export const isQuoteByQTCatNameEqualToCurrentQuote = (qtCatName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const quote = getQuoteByRoomName(qtCatName);
  let newQuoteIndex = quotes.indexOf(quote);
  newQuoteIndex = newQuoteIndex < 0 ? 0 : newQuoteIndex

  return activeQuoteIndex === newQuoteIndex
}
/**
 * @param qtCatName string
 */
export const loadQuoteByQtCatName = async (qtCatName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const quote = getQuoteByRoomName(qtCatName);
  let quoteIndex = quotes.indexOf(quote);
  quoteIndex = quoteIndex < 0 ? 0 : quoteIndex

  store.dispatch(setActiveQuoteIndex(quoteIndex));
  //await setNewActiveQuote(quoteIndex, quotes);
  loadActiveQuoteToSQFT().then();

  //todo fix error if quote is null
  store.dispatch(setSQFTActiveRoomId(qtCatName));
  store.dispatch(setSQFTActiveRoomIndex(null)); //todo if this is critical (set active room in qtCategory switcher)
  store.dispatch(setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.quote));
}


/**
 * load quotes[activeQuoteIndex] to workspace
 */
export const getQuoteByRoomName = (roomName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  return quotes.find((quote, index) => {
    const quoteByQtCatName = quote.qtCatName === roomName.trim().toLowerCase();
    const roomNameInQuote = getRoomNameInQuote(index);
    const quoteByRoomName = roomNameInQuote.trim().toLowerCase() === roomName.trim().toLowerCase();

    return quoteByQtCatName || quoteByRoomName
  });
}

/**
 * load quotes[activeQuoteIndex] to workspace
 */
export const loadActiveQuoteToSQFT = async () => {
  let payload = onSQFTLoadPrepareData();
  onSQFTLoadImport(payload);
}

/**
 * Checking type of current room and creates new or updating existing quote
 * @param sqftCalcData {object}
 */
export const saveSQFTDataToQuote = async (sqftCalcData = null) => {
  const state = store.getState();
  const activeRoomType = state.sqftMenuState.activeRoomType;
  const qtActiveCategory = state.qtState.qtActiveCategory;
  const activeRoomId = state.sqftMenuState.activeRoomId;
  const cartItems = state.cartState.cartItems;
  const activeRoomIndex = state.sqftMenuState.activeRoomIndex;

  if (activeRoomType === ACTIVE_ROOM_TYPE.category) {
    await createQuoteIfNotExistOrUpdateCurrent(qtActiveCategory.trim().toLowerCase());
  } else if (activeRoomType === ACTIVE_ROOM_TYPE.roomGroup) {
    //const roomNavItem = getRoomGroupById(activeRoomId);
    //const roomNavItemName = roomNavItem.part.partName.trim().toLowerCase();
    await createQuoteIfNotExistOrUpdateCurrent(activeRoomId);
  } else {
    if (!sqftCalcData) {
      sqftCalcData = await prepareSQFTData();
      console.log("sqft prepared data", sqftCalcData);
    }
    updateActiveQuoteWithSQFTData(sqftCalcData);
    const quoteRoomCartItem = getCurrentQuoteRoomCartItem(cartItems, activeRoomIndex);
    if (!quoteRoomCartItem) {
      addRoomToCart(getQtCatName());
    }
  }
}

/**
 * Update specific quote with sqFtCalcData by given index
 */
export const updateQuoteWithSQFTData = (data, quoteIndex) => {
  const state = store.getState();
  const { quotes } = state.quotesState;

  const newQuotes = quotes.map((quote, qIndex) => {
    if (qIndex === quoteIndex) {
      return {
        ...quote,
        sqFtCalcData: { ...data }
      };
    }
    return quote;
  });

  store.dispatch(setQuotes(newQuotes));
};

/**
 * Update active quote with sqFtCalcData
 */
export const updateActiveQuoteWithSQFTData = (data) => {
  const state = store.getState();
  const { activeQuoteIndex } = state.quotesState;

  updateQuoteWithSQFTData(data, activeQuoteIndex);
};

export const getSQFTIdsFromAllParentLists = (parentsLists) => {
  const SQFTIds = [];

  parentsLists.forEach(parentsList => {
    Object.keys(parentsList).forEach(parentKey => {
      if (!parentsList[parentKey]) {
        return;
      }

      if (parentsList[parentKey].features && parentsList[parentKey].features.length) {
        parentsList[parentKey].features.forEach(sqftFeature => {
          if (sqftFeature.sqftId) {
            SQFTIds.push(sqftFeature.sqftId);
          }
        });
      }

      if (parentsList[parentKey].featuresSubGroups) {
        parentsList[parentKey].featuresSubGroups.forEach(featureGroup => {
          if (featureGroup && featureGroup.features && featureGroup.features.length) {
            featureGroup.features.forEach(sqftFeature => {
              if (sqftFeature.sqftId) {
                SQFTIds.push(sqftFeature.sqftId);
              }
            });
          }
        });
      }
    });
  });

  return SQFTIds;
};

/**
 */
export const deleteCartItemsThatAreMissingInParentLists = (parentsLists, cartItems) => {
  const sqftIds = getSQFTIdsFromAllParentLists(parentsLists);
  const itemsToRemove = cartItems.filter(cItem => cItem.sqftId && !sqftIds.includes(cItem.sqftId));

  itemsToRemove.forEach(cItem => {
    store.dispatch(removeFromCart(cItem));
  });
};

/**
 * This will return string ids
 * @param SQFTCalcData
 * @return {[]}
 */
export const getSQFTIdsFromSQFTCalcData = (SQFTCalcData) => {
  if (SQFTCalcData) {
    const SQFTIds = [];
    SQFTCalcData.countertops.forEach(countertop => {
      SQFTIds.push(countertop.id.toString());
    })

    if (SQFTCalcData.controllers && SQFTCalcData.controllers.hinge) {
      SQFTCalcData.controllers.hinge.forEach(model => {
        SQFTIds.push(model.id.toString());
      })
    }

    if (SQFTCalcData.controllers && SQFTCalcData.controllers.handles) {
      SQFTCalcData.controllers.handles.forEach(model => {
        SQFTIds.push(model.id.toString());
      })
    }


    return SQFTIds
  }
}

/**
 */
export const deleteCartItemsThatAreMissingInSQFTCalcData = () => {
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  const fabricatorSettings = state.fabricatorState.settings;
  const quotes = state.quotesState.quotes;

  quotes.forEach((quote, quoteIndex) => {
    if (quote.sqFtCalcData) {
      const sqftIds = getSQFTIdsFromSQFTCalcData(quote.sqFtCalcData);

      cartItems
        .filter(cItem => cItem.currentQuote === quoteIndex)
        .forEach(cItem => {
          if (cItem.sqftQuantities) {
            const updatedQuantities = { ...cItem.sqftQuantities };

            // remove sqftIds from sqftQuantities that are not in the SQFTCalcData
            Object.keys(updatedQuantities).forEach(sqftId => {
              if (!sqftIds.includes(sqftId)) {
                delete updatedQuantities[sqftId];
              }
            });

            let newQuantity = Object.values(updatedQuantities).reduce((sum, qty) => sum + qty, 0);
            // The deleteCartItemsThatAreMissingInSQFTCalcData functionality is linked to this section.
            // If any changes are needed, ensure to update both places to maintain consistency.
            //if (PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART.includes(cItem.partId)) {
            newQuantity = fabricatorSettings.measureUnit === MEASURE_UNITS.Metric
              ? Math.ceil10(newQuantity, -2)
              : Math.ceil(newQuantity);
            //}

            // Update the cart item
            if (Object.keys(updatedQuantities).length > 0) {
              store.dispatch(changeCartFeature({
                ...cItem,
                sqftQuantities: updatedQuantities,
                quantity: newQuantity,
              }));
            } else {
              store.dispatch(removeFromCart(cItem));
            }
          }
        });
    }
  })
};

/**
 * @param qtCatName: string
 */
export const createQuoteIfNotExistOrUpdateCurrent = async (qtCatName) => {
  const currentQtCategoryInQuotes = getQuoteForCurrentQtCatName(qtCatName);
  const sqftCalcData = await prepareSQFTData();
  if (!currentQtCategoryInQuotes) {
    await createQuoteFromSqftCalcData(sqftCalcData, qtCatName)
  } else {
    updateActiveQuoteWithSQFTData(sqftCalcData);
  }
}

/**
 * @param sqftCalcData {object}
 * @param qtCatName {string}
 */
export const createQuoteFromSqftCalcData = async (sqftCalcData, qtCatName) => {
  if (!workspace.isEmpty() || isManualCalculateNotEmpty(sqftCalcData)) {
    await createNewQuoteFromCategory(sqftCalcData, qtCatName);
  }
}

/**
 * @param qtCatName string
 */
export const getQuoteForCurrentQtCatName = (qtCatName) => {
  const {quotes} = store.getState().quotesState;
  return quotes.find(quote =>
    quote.qtCatName === qtCatName
    && quote.isVisibleInSQFT === false)
}

/**
 * @param sqftCalcData {object}
 * @param qtActiveCategory {string}
 */
export const createNewQuoteFromCategory = async(sqftCalcData, qtActiveCategory) => {
  if (!workspace.isEmpty() || isManualCalculateNotEmpty(sqftCalcData)) {
    const quotes = await addNewQuote(sqftCalcData, qtActiveCategory);
    store.dispatch(setActiveQuoteIndex(quotes.length - 1));
    addRoomToCart(qtActiveCategory);
  }
}

export const isManualCalculateNotEmpty = (sqftCalcData) => {
  if (sqftCalcData.manualCalculate) {
    return sqftCalcData.countertops.length > 0
      || sqftCalcData.backsplashes.length > 0
      || sqftCalcData.edges.length > 0
  }

  return false
}
/**
 * @param sqftCalcData {object}
 * @param qtActiveCategory {string}
 */
const addNewQuote = async (sqftCalcData, qtActiveCategory) => {
  //const currentQuote = await updateCurrentQuote();
  const {quotes} = store.getState().quotesState;
  const newQuotes = [...quotes, {
    quoteId: null,
    isCreatedInSQFT: true,
    isVisibleInSQFT: false,
    qtCatName: qtActiveCategory.trim().toLowerCase(),
    sqFtCalcData: sqftCalcData
  }];
  store.dispatch(setQuotes(newQuotes));

  return newQuotes
};

/**
 * @param qtCatName {string}
 */
export const addRoomToCart = (qtCatName) => {
  const roomCartItem = getRoomCartItemForCategoryName(qtCatName)
  if (roomCartItem) {
    store.dispatch(addToCart([roomCartItem]))
    return roomCartItem
  }
}

/**
 * update navItemBy roomIndex
 * @param roomName {string}
 */
export const getRoomGroupById = (roomName) => {
  const roomsFeatureGroup = getFeatureGroup('room');
  const roomsNavItems = getNavItems(roomsFeatureGroup, "", {}, false, true);

  return roomsNavItems.find(navItem => {
    return navItem.part.getFeatureName().toLowerCase() === roomName.toLowerCase()
  });
}
